export default "__VITE_ASSET__24751650__"